module.exports = __webpack_public_path__ + "static/media/Image_08.46047855.jpeg";